import React from 'react';
import PropTypes from 'prop-types';

/**
 * Button provides a standardized template for displaying working button elements
 *
 * Uniform Dependencies
 * @requires css:components/buttons
 */
export default class Button extends React.Component {
  render() {
    const {
      as: T,
      secondary,
      block,
      tall,
      bare,
      disabled,
      icon,
      labeled,
      margin,
      padding,
      width,
      minWidth,
      dataQA,
      onClick,
      children,
      ariaPressed,
      reference,
      ...props
    } = this.props;

    const classNames = [
      'button',
      secondary && 'secondary',
      bare && 'bare',
      disabled && 'disabled',
      icon && 'icon',
      labeled && 'labeled'
    ].filter(c => c).join(' ');

    return (
      <T
        style={{
          margin,
          width,
          minWidth,
          display: block ? 'block' : null,
          paddingTop: tall ? '0.75em' : null,
          paddingBottom: tall ? '0.75em' : null,
          padding,
          fontFamily: 'inherit'
        }}
        data-qa={dataQA}
        disabled={disabled}
        className={classNames}
        onClick={onClick}
        aria-pressed={ariaPressed}
        ref={reference}
        {...props}
      >
        {children}
      </T>
    );
  }
}

Button.propTypes = {
  as: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.elementType]),
  secondary: PropTypes.bool,
  block: PropTypes.bool,
  tall: PropTypes.bool,
  bare: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.bool,
  labeled: PropTypes.bool,
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.string,
  width: PropTypes.string,
  minWidth: PropTypes.string,
  dataQA: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  /**
   * ariaPressed is a prop to add the ADA compliant attribute aria-pressed
   * to buttons that toggle between two states: i.e a button that copies
   * text toggles between "Copy" and "Copied"
   * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#associated_aria_roles_states_and_properties
   */
  ariaPressed: PropTypes.bool,
  reference: PropTypes.object
};

Button.defaultProps = {
  as: 'button',
  disabled: false
};



// WEBPACK FOOTER //
// ./src/main/webapps/common/react/components/button.js